import { useState } from 'react'

import Image from 'next/image'

import type { EshopAPI } from '@twisto/api-cms/custom-types'
import { useAppConfig } from '@twisto/base'

import { AccessibleDiv } from '../atoms'

import * as styles from './eshop-card.styles'

type EshopCardProps = {
  shop: EshopAPI
  origin: string
  variant?: 'default' | 'compact'
}

export const EshopCard = ({
  shop,
  origin,
  variant = 'default',
}: EshopCardProps) => {
  const { region } = useAppConfig()
  const [isLogoPresent, setIsLogoPresent] = useState(true)

  const eshopUrl = region === 'CZ' ? 'seznam-eshopu' : 'nasze-sklepy'
  const { id, url, logo } = shop

  const fullWhiteLogo = `${origin}/${eshopUrl}/${id}/logo_full_white/`
  const background = `${origin}/${eshopUrl}/${id}/background_image/`
  const logoUrl = logo && `${origin}/static/${logo}`
  const isCompact = variant === 'compact'

  return (
    <AccessibleDiv
      css={isCompact ? styles.compact : styles.eshop}
      role="link"
      onActivate={() => window.open(url, '_blank')}
    >
      {isCompact ? (
        <Image
          alt="Eshop Background"
          css={styles.logo}
          height={330}
          src={logoUrl || ''}
          width={330}
        />
      ) : (
        <div css={styles.content}>
          <div className="eshop__shadow" css={styles.shadow}>
            <Image
              unoptimized
              alt="Eshop Background"
              css={styles.background}
              height={330}
              src={background}
              width={330}
            />
          </div>
          {isLogoPresent && (
            <Image
              unoptimized
              alt="Eshop Logo"
              css={styles.foreground}
              height={58}
              src={fullWhiteLogo}
              width={230}
              onError={() => {
                setIsLogoPresent(false)
              }}
            />
          )}
        </div>
      )}
    </AccessibleDiv>
  )
}
